import { render } from "./AccountPlans.vue?vue&type=template&id=52358014"
import script from "./AccountPlans.vue?vue&type=script&lang=js"
export * from "./AccountPlans.vue?vue&type=script&lang=js"

import "./AccountPlans.vue?vue&type=style&index=0&id=52358014&lang=css"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__